import { render, staticRenderFns } from "./current-news-page.vue?vue&type=template&id=30d50e82&scoped=true&"
import script from "./current-news-page.vue?vue&type=script&lang=js&"
export * from "./current-news-page.vue?vue&type=script&lang=js&"
import style0 from "./current-news-page.vue?vue&type=style&index=0&id=30d50e82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d50e82",
  null
  
)

export default component.exports